import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://cgirfawbyfrpmqbngjdg.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNnaXJmYXdieWZycG1xYm5namRnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg3Mjc1ODksImV4cCI6MjA3NDMwMzU4OX0.YkhyBSHHdY1yRcWScKPJaDtb72fxvBEPiOU1PwT71Fk'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
